// extracted by mini-css-extract-plugin
module.exports = {"customInput":"index_customInput__3u_0f","wrapperRemove":"index_wrapperRemove__34Oul","removeIcon":"index_removeIcon__Av6zV","actionBtn":"index_actionBtn__2aRDL"};